// extracted by mini-css-extract-plugin
module.exports = {"titleBlockWrapper":"StrategyTitleBlock_titleBlockWrapper__1LeNP","stepsTemplated":"StrategyTitleBlock_stepsTemplated__1vG5w","steps":"StrategyTitleBlock_steps__1vhlR"};